module.exports = __webpack_public_path__ + "static/media/facebook.b4758b74.png";